<script>
    
    </script>
    
    <main>
    <h2>Access statement</h2>
    <p>
        All the accommodation is contained within Maesygarnedd farm which is accessed via a private road from the A496 in Llanelltyd village. Both the cottages (Y Warws and Y Warws Bach) were converted from a 17th Century warehouse which originally formed an important part of the commercial trading by boat along the Mawddach estuary.
    </p>
    
    <p>
        The cottages are approached via the private access road from the A496 Llanelltyd to Barmouth road. Luggage can be unloaded immediately adjacent to both cottages. Private parking on rolled gravel is provided for both properties and access is via flat even surface. Access for our guests to the nearby tidal river Mawddach flowing through our land is possible via soft and uneven ground.
    </p>
    <p>
        Local taxi's service the premises and a regular bus service is available. Both cottages have wooden floors and oak stairways to first floors. Light switches and power points at a sensible height throughout the buildings. The owners live on site at the farm house and are available at most times.
    </p>
    
    <h2>
        Y Warws (4 person)
    </h2>
    <p>
        Entrance via wide doorway and small step. Open plan dining room/ kitchen and lounge area with French window and small balcony. Two bedrooms on first floor, both of which have an en-suite shower room with sink and w/c. One bedroom has a double bed and the other has twin beds.
    </p>
    <h2>
        Y Warws (2 person)
    </h2>
    Access via wide balcony. Entrance doorway has a small downward step. Open plan dining room/ kitchen and lounge area. First floor bedroom with en-suite shower room, sink and w/c.
    <p>
    
    </p>
    </main>
 
    <style>
    
    main{
        width: 60vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: auto;
        
    }
    h2{
        color: #7A7361;
    }
    @media screen and (max-width: 800px) {
        main {
          width: 100%;
          padding: 10px;
        }
      }
    </style>